var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 189,
    viewBox: "0 0 187 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 93.5,
    cy: 175.5,
    rx: 93.5,
    ry: 10.5,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1508_32083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7751 178.291C34.3905 178.293 34.0204 178.144 33.7443 177.876C33.4682 177.608 33.308 177.242 33.2982 176.857L39.122 112.242H44.9141L36.2535 176.857C36.2433 177.242 36.0828 177.608 35.8065 177.876C35.5301 178.144 35.1599 178.293 34.7751 178.291Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0383 178.291C70.4231 178.293 70.7933 178.144 71.0697 177.876C71.346 177.608 71.5065 177.242 71.5167 176.857L65.6928 112.242H59.9008L68.557 176.857C68.5669 177.243 68.7276 177.609 69.0047 177.877C69.2818 178.145 69.653 178.294 70.0383 178.291Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3307 104.109H31.4833C29.2865 104.109 27.5056 105.892 27.5056 108.091V108.262C27.5056 110.461 29.2865 112.243 31.4833 112.243H73.3307C75.5276 112.243 77.3084 110.461 77.3084 108.262V108.091C77.3084 105.892 75.5276 104.109 73.3307 104.109Z",
    fill: "white",
    stroke: "#FFB000",
    strokeWidth: 1.16087,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.411 176.017C136.411 176.017 127.323 176.017 123.05 175.991C119.456 175.968 112.335 176.281 112.268 174.55C112.206 172.956 113.818 168.809 114.067 167.411C116.91 167.495 119.73 166.877 122.278 165.613C123.205 166.519 128.37 171.402 132.613 171.902C137.293 172.454 136.411 176.017 136.411 176.017Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7308 178.953C80.7308 178.953 67.9131 179.16 66.3536 178.953C64.7941 178.745 60.3849 175.067 60.3849 175.067C60.3849 171.904 62.4425 168.382 62.9493 167.195C64.6869 167.723 67.5627 168.292 71.3941 168.004C71.4911 169.093 72.0732 172.919 75.4485 173.367C81.0393 174.103 80.7308 178.953 80.7308 178.953Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0258 174.363C70.0258 174.363 72.0935 172.951 75.5861 172.934",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6598 84.2129C45.6598 84.2129 39.5666 95.2152 42.0079 103.345C44.4493 111.474 58.896 110.132 58.896 110.132C58.896 110.132 54.2827 128.266 61.0275 166.453C61.0275 166.453 66.3518 169.351 75.4381 167.416C75.4381 167.416 76.7949 149.634 83.0981 110.345L94.9717 111.031C94.9717 111.031 90.396 132.638 111.863 167.142C111.863 167.142 117.885 168.737 124.531 164.321C124.531 164.321 116.133 125.371 114.702 101.526C114.282 94.5036 102.296 88.0118 78.7207 84.0781C78.7207 84.0781 54.0018 85.6406 45.6598 84.2129Z",
    fill: "#424D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.535 110.493C84.0142 107.739 86.431 95.9989 70.8301 92.1406",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3852 105.664C60.3852 105.664 59.0111 107.444 58.4608 110.431",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7268 79.1482C79.7268 79.1482 93.9376 51.2591 95.6347 42.47C97.8269 31.1387 93.1513 27.0949 90.3625 26.1847C87.5736 25.2745 68.7871 20.2422 68.7871 20.2422C65.3293 20.7379 50.4134 23.67 45.4858 26.7354C42.9822 28.3095 45.7117 79.4293 45.7117 79.4293C44.8125 82.2194 41.8716 89.1707 41.8716 89.1707C41.8716 89.1707 51.5327 92.826 69.4735 89.9417L73.0197 84.3543C73.0197 84.3543 75.2728 88.3996 76.2342 88.688C77.1957 88.9764 82.8719 87.6097 85.3147 85.3124C85.3147 85.3052 79.7182 81.3599 79.7268 79.1482Z",
    fill: "#DBDAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2077 41.0792C73.7867 41.0792 74.2561 40.6094 74.2561 40.0298C74.2561 39.4503 73.7867 38.9805 73.2077 38.9805C72.6287 38.9805 72.1594 39.4503 72.1594 40.0298C72.1594 40.6094 72.6287 41.0792 73.2077 41.0792Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2077 50.7979C73.7867 50.7979 74.2561 50.3281 74.2561 49.7486C74.2561 49.169 73.7867 48.6992 73.2077 48.6992C72.6287 48.6992 72.1594 49.169 72.1594 49.7486C72.1594 50.3281 72.6287 50.7979 73.2077 50.7979Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0348 59.3878C73.6138 59.3878 74.0832 58.918 74.0832 58.3384C74.0832 57.7589 73.6138 57.2891 73.0348 57.2891C72.4558 57.2891 71.9865 57.7589 71.9865 58.3384C71.9865 58.918 72.4558 59.3878 73.0348 59.3878Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4553 66.7784C73.0343 66.7784 73.5036 66.3086 73.5036 65.729C73.5036 65.1495 73.0343 64.6797 72.4553 64.6797C71.8763 64.6797 71.4069 65.1495 71.4069 65.729C71.4069 66.3086 71.8763 66.7784 72.4553 66.7784Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8757 75.4737C72.4547 75.4737 72.924 75.0039 72.924 74.4244C72.924 73.8448 72.4547 73.375 71.8757 73.375C71.2967 73.375 70.8273 73.8448 70.8273 74.4244C70.8273 75.0039 71.2967 75.4737 71.8757 75.4737Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1385 82.8682C70.7175 82.8682 71.1868 82.3984 71.1868 81.8189C71.1868 81.2393 70.7175 80.7695 70.1385 80.7695C69.5595 80.7695 69.0901 81.2393 69.0901 81.8189C69.0901 82.3984 69.5595 82.8682 70.1385 82.8682Z",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5679 18.9258C68.5679 18.9258 72.1604 24.2421 73.2725 27.1192C73.2725 27.1192 71.1208 27.2989 68.7953 30.089C68.7953 30.089 62.0533 24.2349 61.0151 21.7579C61.0151 21.7579 67.0692 19.3258 68.5679 18.9258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6321 22.9844C73.127 27.1209 75.6335 32.946 76.0375 37.1971C76.301 39.9668 75.4829 70.6692 75.4829 70.6692C75.3627 73.7781 75.5944 82.6194 69.3289 89.646",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0372 37.1937L81.6801 28.4844",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.781 25.6995C35.108 29.51 25.0429 54.1423 28.8469 66.4664C30.0154 70.2508 39.4014 70.7653 48.4818 70.7551C60.6451 70.7421 75.4626 70.6653 75.4626 70.6653L75.7971 64.3242C75.7971 64.3242 58.8293 56.5584 47.823 56.3671C47.8288 56.3671 65.6726 20.3209 47.781 25.6995Z",
    fill: "#DBDAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4617 70.6678L75.5456 64.3499C75.5456 64.3499 58.8617 56.7986 47.8279 56.2145C47.8279 56.2145 51.3031 48.1863 53.5721 40.5234",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8615 69.9135C75.8615 69.9135 78.3824 72.6673 80.566 72.0672C82.7496 71.4672 84.7884 71.0396 85.9396 71.5556C87.363 72.1933 88.8226 73.692 89.7247 73.6123C90.8166 73.5264 91.8819 73.2312 92.8625 72.7427C92.2326 71.6124 91.5458 70.5147 90.8049 69.454C91.5984 69.8961 92.6685 70.8382 93.2506 71.1846C94.186 71.7469 94.7652 70.8454 94.7652 70.8454C94.7652 70.8454 93.0898 68.7206 92.3774 68.1829C91.694 67.6655 89.2425 66.0784 88.2043 65.9842C86.9532 65.7581 79.3077 63.8173 75.8861 64.2449L75.8615 69.9135Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7251 72.8316C91.7251 72.8316 88.7422 68.9415 87.9603 68.7009C86.5832 68.2762 84.7877 67.7109 84.7877 67.7109",
    stroke: "#A85F2B",
    strokeWidth: 0.497515,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3977 73.2731C90.3977 73.2731 87.7232 70.0381 86.9427 69.7946C85.5657 69.3685 83.7701 68.8047 83.7701 68.8047",
    stroke: "#A85F2B",
    strokeWidth: 0.497515,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9874 62.9375L69.1333 71.1033",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7174 71.1926C56.8807 71.1796 75.463 70.668 75.463 70.668",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.218 85.8977C141.147 86.8818 145.079 91.4213 146.723 91.8967C148.368 92.3721 153.551 91.3024 153.963 91.0517C154.376 90.8009 156.741 88.8675 156.741 88.8675C156.741 88.8675 155.957 87.3224 154.25 88.3167C152.223 89.4965 149.743 88.1602 148.704 87.1572C148.27 86.7427 147.943 85.3353 148.654 84.7483C149.365 84.1613 151.078 85.702 151.778 85.7629C152.849 85.8614 153.622 84.8425 153.622 84.8425C153.622 84.8425 150.846 82.5568 150.316 82.1162C149.786 81.6756 145.96 80.0697 142.893 80.4262C139.827 80.7828 138.061 83.6178 140.218 85.8977Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9668 26.1953C89.9668 26.1953 98.0858 27.6085 103.743 34.209C108.242 39.4557 118.096 59.1036 118.495 59.5037C118.895 59.9037 139.817 76.2412 143.812 79.7197C143.812 79.7197 140.677 81.1691 139.313 86.9347C139.313 86.9347 112.648 78.5834 104.621 70.0755C93.3016 58.0717 81.9492 40.3167 89.9668 26.1953Z",
    fill: "#DBDAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 76.5312C140.337 76.5312 135.413 79.1691 134.824 85.4856",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7644 43.7734C94.7644 43.7734 93.884 49.6333 92.045 53.7742",
    stroke: "white",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.997 87.9961H162.625C166.431 87.9961 169.512 91.2554 169.512 95.2602V121.131C169.512 125.144 172.598 128.395 176.399 128.395H148.766C144.963 128.395 141.88 125.136 141.88 121.131V95.5332C141.903 93.9486 141.38 92.4043 140.398 91.1614C139.415 89.9184 138.035 89.0529 136.489 88.7111L134.993 88.4402L134.997 87.9961Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 1.16539,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.344 106.352H164.68M146.344 108.274H164.68M146.344 110.547H164.68M146.344 112.469H164.68",
    stroke: "#4B69B2",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.344 106.352H164.68M146.344 108.274H164.68M146.344 110.547H164.68M146.344 112.469H164.68",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.344 118.586H164.68M146.344 120.509H164.68",
    stroke: "#4B69B2",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.344 118.586H164.68M146.344 120.509H164.68",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.896 95.2212C161.896 95.5743 161.61 95.8604 161.257 95.8604C160.904 95.8604 160.618 95.5743 160.618 95.2212C160.618 94.8682 160.904 94.582 161.257 94.582C161.61 94.582 161.896 94.8682 161.896 95.2212ZM152.661 98.9779L154.571 95.8466L155.174 96.8076L152.811 100.681C152.688 100.882 152.752 101.144 152.952 101.267C153.153 101.389 153.416 101.326 153.538 101.125L155.68 97.6145L157.739 100.897C157.974 101.272 158.521 101.269 158.752 100.892L159.331 99.9484L159.926 100.897C160.161 101.272 160.708 101.269 160.94 100.892L163.481 96.7509C163.604 96.5503 163.541 96.2879 163.34 96.1648C163.14 96.0418 162.878 96.1046 162.754 96.3052L160.429 100.095L159.829 99.1376L161.293 96.7509C161.416 96.5503 161.354 96.2879 161.153 96.1648C160.952 96.0418 160.69 96.1046 160.567 96.3052L159.323 98.3317L157.261 95.0436C157.026 94.6681 156.478 94.6714 156.247 95.0498L155.67 95.9945L154.968 94.8746C154.781 94.5767 154.346 94.5794 154.163 94.8795L151.933 98.534C151.694 98.9266 151.095 98.8068 151.025 98.3523L150.182 98.4822C150.374 99.722 152.007 100.049 152.661 98.9779ZM156.176 96.8014L158.242 100.095L158.826 99.1425L156.759 95.8466L156.176 96.8014ZM163.814 95.8604C164.167 95.8604 164.453 95.5743 164.453 95.2212C164.453 94.8682 164.167 94.582 163.814 94.582C163.461 94.582 163.174 94.8682 163.174 95.2212C163.174 95.5743 163.461 95.8604 163.814 95.8604Z",
    fill: "#4A4D50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.896 95.2212C161.896 95.5743 161.61 95.8604 161.257 95.8604C160.904 95.8604 160.618 95.5743 160.618 95.2212C160.618 94.8682 160.904 94.582 161.257 94.582C161.61 94.582 161.896 94.8682 161.896 95.2212ZM152.661 98.9779L154.571 95.8466L155.174 96.8076L152.811 100.681C152.688 100.882 152.752 101.144 152.952 101.267C153.153 101.389 153.416 101.326 153.538 101.125L155.68 97.6145L157.739 100.897C157.974 101.272 158.521 101.269 158.752 100.892L159.331 99.9484L159.926 100.897C160.161 101.272 160.708 101.269 160.94 100.892L163.481 96.7509C163.604 96.5503 163.541 96.2879 163.34 96.1648C163.14 96.0418 162.878 96.1046 162.754 96.3052L160.429 100.095L159.829 99.1376L161.293 96.7509C161.416 96.5503 161.354 96.2879 161.153 96.1648C160.952 96.0418 160.69 96.1046 160.567 96.3052L159.323 98.3317L157.261 95.0436C157.026 94.6681 156.478 94.6714 156.247 95.0498L155.67 95.9945L154.968 94.8746C154.781 94.5767 154.346 94.5794 154.163 94.8795L151.933 98.534C151.694 98.9266 151.095 98.8068 151.025 98.3523L150.182 98.4822C150.374 99.722 152.007 100.049 152.661 98.9779ZM156.176 96.8014L158.242 100.095L158.826 99.1425L156.759 95.8466L156.176 96.8014ZM163.814 95.8604C164.167 95.8604 164.453 95.5743 164.453 95.2212C164.453 94.8682 164.167 94.582 163.814 94.582C163.461 94.582 163.174 94.8682 163.174 95.2212C163.174 95.5743 163.461 95.8604 163.814 95.8604Z",
    fill: "url(#paint0_linear_1508_32083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9428 15.1836C75.4302 15.8663 74.612 18.8216 69.3688 20.2564C69.3688 20.2564 74.8292 27.3715 76.1744 36.3301L81.9665 27.3309L75.9428 15.1836Z",
    fill: "#A85F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9526 9.8225C97.5284 11.1994 95.5185 11.0849 95.5113 11.3371C95.5041 11.5893 96.5799 12.0618 96.3352 13.1981C96.1021 14.2779 95.2202 14.4547 94.4311 14.3779C94.4299 14.3007 94.4231 14.2237 94.4108 14.1475C93.8664 10.9182 86.2759 8.14846 82.986 10.366C80.9151 11.7904 79.3918 13.8797 78.6681 16.2882C78.6681 16.2882 77.9629 14.0866 76.609 14.5779C76.3842 14.6529 76.1789 14.7772 76.0081 14.9417C76.318 13.5199 76.9203 9.52248 76.8957 8.57748C76.8668 7.50059 74.6672 4.78154 76.3672 3.06981C78.0672 1.35809 80.0307 2.69442 80.0307 2.69442C80.0307 2.69442 80.9588 -0.143476 83.6869 0.00146236C86.1123 0.146401 86.7277 1.74073 86.7277 1.74073C86.7277 1.74073 87.3996 0.371056 88.697 0.630496C88.9806 0.695827 89.2479 0.818496 89.4825 0.99097C89.717 1.16344 89.9139 1.38209 90.061 1.63347C90.061 1.63347 91.6828 0.581217 92.8557 1.45085C93.1847 1.67983 93.4308 2.00931 93.5571 2.38999C93.6835 2.77067 93.6833 3.18207 93.5565 3.5626C93.5565 3.5626 95.8313 2.7495 97.0158 4.57718C97.7977 5.77872 96.5886 7.4629 96.5886 7.4629C96.5886 7.4629 98.387 8.44414 97.9526 9.8225Z",
    fill: "#424D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5633 19.2913C77.5633 19.2913 75.9517 22.9148 78.4973 25.5237C81.554 28.6601 85.1885 29.6008 86.4613 29.5153C87.7341 29.4298 94.8916 16.9506 94.4254 14.1518C93.8809 10.9226 86.2905 8.15133 83.0006 10.3689C80.9294 11.7937 79.4061 13.8834 78.6826 16.2925C78.6826 16.2925 77.976 14.0909 76.6221 14.5823C74.0606 15.5113 77.5633 19.2913 77.5633 19.2913Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9215 11.543C80.5147 12.5575 77.3015 18.3942 79.5763 21.3234C81.8512 24.2526 83.5468 19.9958 87.8401 21.5162C90.4002 22.4206 89.7718 24.9773 89.7718 24.9773C89.7718 24.9773 89.0362 26.5919 87.9487 29.9284C87.7011 30.6836 78.2644 29.0588 76.8425 22.9221C76.2242 20.2567 77.9691 16.1013 79.3664 13.646C80.2062 12.1648 80.9215 11.543 80.9215 11.543Z",
    fill: "#424D76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1508_32083",
    x1: 151.236,
    y1: 96.1161,
    x2: 164.493,
    y2: 98.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B69B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1508_32083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 189,
    fill: "white",
    transform: "translate(27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.3e0a09171b3826786ffb3c8f8e49c966.svg";
export { ForwardRef as ReactComponent };